export const DISCONNECTED = "DISCONNECTED";
export const CONNECTED = "CONNECTED";
export const ERROR = "ERROR";
export const NO_CLIENT = "NO_CLIENT";

export const EMPTY_USER_STATE = { username: "", status: DISCONNECTED };
export const EMPTY_WALLET_STATE = { address: "", status: DISCONNECTED };
